import { createSlice } from "@reduxjs/toolkit";
import { faqApi } from "./faq.api";
// Api response type
const initialState = {
    faqs: []
};
export const faqSlice = createSlice({
    name: "faq",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addMatcher(faqApi.endpoints.getFaq.matchFulfilled, (state, action) => {
            return Object.assign(Object.assign({}, state), action.payload);
        });
    }
});
//# sourceMappingURL=faq.slice.js.map